import { render, staticRenderFns } from "./form-section.vue?vue&type=template&id=0fa76215"
import script from "./form-section.vue?vue&type=script&lang=js"
export * from "./form-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports